export default __webpack_public_path__ + "static/media/dai.6663cf6d.svg";